module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/LadiesinLavender-448x252.680a0db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/LadiesinLavender-448x252.jpg
// module id = ZEXl
// module chunks = 0